import { useEffect, useRef } from 'react';
import { getDeviceType } from '../../../Utils/helper';
import {
  AskQuestionLogo,
  AskYourQuestion,
  BlackButton,
  CardSectionAskNow,
  GetExpertAns,
  MobileFlex,
} from './styled';
import {
  fireClickedCardEvent,
  fireServedSectionEvent,
} from '../../../Utils/useFirebase';

export default function AskNow({
  installLink,
  description,
  setShowDesktopNotifPopup,
}) {
  // const router = useRouter();
  const isDesktop = useRef();
  const clickHandler = () => {
    // if (isDesktop.current) {
    //     setShowDesktopNotifPopup(true);
    // } else {
    window.location.href = installLink;
    // }
  };
  const descriptionString = `Ask your question ${
    description ? `about ${description.toLowerCase()}` : null
  }`;
  useEffect(() => {
    fireServedSectionEvent(descriptionString, null, 'topic');
    isDesktop.current = getDeviceType() === 'desktop';
  }, []);
  return (
    // <Link
    //     href={{
    //         pathname: installLink,
    //         query: removeDefaultParams(router.query),
    //     }}
    //     passHref
    // >
    //     <a>
    //     </a>
    // </Link>
    <CardSectionAskNow
      onClick={() => {
        (fireClickedCardEvent(
          descriptionString,
          descriptionString,
          'topic',
          null,
          installLink,
        ),
          clickHandler());
      }}
    >
      <MobileFlex>
        <AskQuestionLogo src="/images/ask_question.png" alt="" />
        <div>
          <AskYourQuestion>
            Ask your question{' '}
            {description ? `about ${description.toLowerCase()}` : null}
          </AskYourQuestion>
          <GetExpertAns>
            Get expert answers within 5 minutes for FREE only on Mylo App
          </GetExpertAns>
        </div>
      </MobileFlex>
      <BlackButton>Ask Now</BlackButton>
    </CardSectionAskNow>
  );
}
